
export default function ShapeXLogo({ className = '', width = 300 }: { className?: string; width?: number }) {
    return (
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <svg
                width={width}
                height={width * 0.3}
                viewBox="0 0 300 90"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="select-none"
            >
                {/* Main Text SHAPE */}
                <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontFamily="system-ui, -apple-system, sans-serif"
                    fontWeight="900"
                    fontSize="48"
                    fill="white"
                    letterSpacing="0.05em"
                    style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5))' }}
                >
                    SHAPE
                    <tspan fill="#E53935" dx="2" style={{ filter: 'drop-shadow(0 0 10px rgba(229, 57, 53, 0.6))' }}>X</tspan>
                </text>

                {/* Subtitle Alta Performance */}
                <text
                    x="50%"
                    y="80%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontFamily="system-ui, -apple-system, sans-serif"
                    fontWeight="700"
                    fontSize="14"
                    fill="#A1A1A1"
                    letterSpacing="0.3em"
                    style={{ textTransform: 'uppercase' }}
                >
                    Alta Performance
                </text>
            </svg>
        </div>
    );
}
